<template>
  <div class="card-body">
    <div class="form-row">
      <div class="col-12">
        <div class="alert alert-info">
          <i class="fas fa-info-circle"></i>
          <span>{{ trans('Here you can upload up to 10 pictures. Please upload at least one.') }}</span>
        </div>

        <div :class="{ error: hasError('photos') }">
          <file-pond
            name="file"
            ref="pond"
            :allow-paste="false"
            :label-idle="trans('Drop your files here')"
            :max-files="10"
            :allow-multiple="true"
            :allow-image-preview="true"
            :allow-image-exif-orientation="true"
            :image-preview-height="180"
            :allow-reorder="true"
            accepted-file-types="image/jpeg, image/png"
            :server="serverOptions"
            :files="imageIds"
            @activatefile="updateFileHandler"
            @processfile="updateFileHandler"
            @updatefiles="updateFileHandler" />
        </div>

        <label class="error" v-if="hasError('photos')">{{ errors.photos[0] }}</label>
      </div>
    </div>
  </div>
</template>

<script>
  import vueFilePond from 'vue-filepond';
  import 'filepond/dist/filepond.min.css';
  import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
  // Import image preview and file type validation plugins
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';

  import {apiClient} from '../../api';

  const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginImageExifOrientation
  );

  const csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

  export default {
    name: "VehiclePhotos",

    components: {
      FilePond,
    },

    props: {
      apiRoute: {
        type: String,
        required: true,
      },
      photos: {
        type: Array,
        required: true,
        default: () => [],
      },
      errors: {
        validator: prop => typeof prop === 'object' || prop === null,
        required: true,
        default: {},
      }
    },

    data() {
      return {
        imageIds: this.photos,
        serverOptions: {
          url: '/api',
          process: {
            url: '/photos',
            method: 'POST',
            withCredentials: false,
            headers: {
              'X-CSRF-TOKEN': csrf
            },
          }
        }
      }
    },

    watch: {
      imageIds: {
        handler(val) {
          this.$emit('update:photos', val);
        },
        deep: true
      },
    },

    methods: {
      updateFileHandler() {
        const files = this.$refs.pond.getFiles() || [];
        this.$emit('update:photos', files.map(item => item.serverId).filter(item => Number(item) > 0));
      },

      hasError(fieldName) {
        return this.errors.hasOwnProperty(fieldName);
      }
    },
  }
</script>
